import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer 
      className="pt-16 pb-8"
      style={{ backgroundColor: '#2d6142' }}
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4 text-white">
              Life Care & Wellness
            </h3>
            <p className="text-gray-200 mb-4 leading-relaxed">
              Real people providing genuine, compassionate care. We listen, we understand, and we walk beside you every step of the way. Free consultations and free action plans — because support should never come with a price tag.
            </p>
            <p className="text-gray-300 italic text-sm mb-6 leading-relaxed">
              Individualised programs to reach your goals can look the same at various parts of the journey and unique at the end.
            </p>
            <div className="space-y-3">
              <a 
                href="tel:+611300404229"
                className="flex items-center text-gray-200 hover:text-white transition-colors"
              >
                <Phone className="w-5 h-5 mr-3" />
                1300 404 229
              </a>
              <a 
                href="mailto:admin@lifecarewellness.au"
                className="flex items-center text-gray-200 hover:text-white transition-colors"
              >
                <Mail className="w-5 h-5 mr-3" />
                admin@lifecarewellness.au
              </a>
              <div className="flex items-start text-gray-200">
                <MapPin className="w-5 h-5 mr-3 mt-1 flex-shrink-0" />
                <span>Serving Logan & Brisbane, Queensland</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Our Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('blogs')}
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Blogs
                </button>
              </li>
              <li>
                <button
                  onClick={() => window.location.href = '/contact'}
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Contact
                </button>
              </li>
              <li>
                <button
                  onClick={() => window.location.href = '/get-on-ndis-free'}
                  className="text-white hover:opacity-80 transition-opacity font-semibold"
                >
                  Get on the NDIS Free
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-white">
              Our Services
            </h4>
            <ul className="space-y-3 text-gray-200">
              <li>Support Coordination</li>
              <li>SLES Program</li>
              <li>Counselling Services</li>
              <li>Independent Living</li>
              <li>Personal Training</li>
              <li>NDIS Consulting</li>
            </ul>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="pt-8 border-t border-gray-600">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-200 text-sm">
              Copyright © {currentYear} Life Care and Wellness - All Rights Reserved.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center text-white hover:opacity-80 transition-opacity"
                style={{ backgroundColor: '#6c935e' }}
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center text-white hover:opacity-80 transition-opacity"
                style={{ backgroundColor: '#6c935e' }}
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center text-white hover:opacity-80 transition-opacity"
                style={{ backgroundColor: '#6c935e' }}
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
